import 'core-js';
import AOS from 'aos';
import 'aos/dist/aos.css';
import browserUpdate from 'browser-update';

import { v4 as uuidv4 } from 'uuid';

import App from '../search/app';

import SitePlanApp from './components/InteractiveSitePlan';
import Faqs from './components/FAQs';

import MegaMenu from './base-components/MegaMenu';
import MobileMenu from './base-components/MobileMenu';
import HeroSlider from './base-components/HeroSlider';
import FooterMenus from './base-components/FooterMenus';
import HeroNotificationBar from './base-components/HeroNotificationBar';
import GlobalNotificationBar from './base-components/GlobalNotificationBar';
import TxtImgSlider from './base-components/TxtImgSlider';
import MobNewsSlider from './base-components/MobNewsSlider';
import FancyBox from './base-components/FancyBox';

import Slider from './base-components/Slider';
import OfferSlider from './base-components/OfferSlider';
import SpecificationSlider from './base-components/SpecificationSlider';
import OpeningTimes from './components/OpeningTimes';
import ComingSoonCountDown from './components/ComingSoonCountDown';
import FeatureSlider from './base-components/FeatureSlider';
import Tabs from './components/Tabs';
import FlexibleMap from './components/FlexibleMap';
import ScrollTo from './components/ScrollTo';
import FloorplanTabs from './components/FloorplanTabs';
import WPslider from './base-components/WPslider';
import EnquiryTabs from './components/EnquiryTabs';
import DatePicker from './components/DatePicker';
import Favourites from './components/Favourites';
import Header from './components/HeadRoom';
import IconUp from './base-components/IconUp';
import FaqQuickLinks from './base-components/FaqQuickLinks';
import Countdown from './components/Countdown';
// import isSupported from './components/BrowserFallback';
import PlotCta from './components/PlotCta';
import SitePlan from './siteplan';

import DevelopmentNewsBanner from './components/DevelopmentNewsBanner';
import AudienceCookie from './base-components/AudienceCookie';
import ContentSwitcher from './components/ContentSwitcher';
import FormConfirmation from './components/FormConfirmation';
import OpeningHours from './base-components/OpeningHours';
import FloorplanFurniture from './components/FloorplanFurniture';
import UtmTracking from './UtmTracking';

import CookiePreferences from './base-components/CookiePreferences';

AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)9
  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: window.innerHeight * 0.1, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 1000, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
});

window.addEventListener('load', AOS.refresh);

browserUpdate({
  required: {
    e: -2,
    f: -2,
    o: -2,
    s: -2,
    c: '64.0.3282.16817',
    samsung: 7.0,
    vivaldi: 1.2,
  },
  insecure: true,
  unsupported: true,
});

MegaMenu();
FooterMenus();
FancyBox();
ScrollTo();
WPslider();
Favourites();
Header();
IconUp();
UtmTracking();

{
  const cookiePreferences = document.querySelector(
    '.footer__cookie-preferences'
  );
  if (typeof cookiePreferences !== 'undefined' && cookiePreferences != null) {
    CookiePreferences();
  }
}

{
  const countdown = document.querySelector('.countdown');
  if (typeof countdown !== 'undefined' && countdown != null) Countdown();
}

// UUID for Google API calls
{
  const uuid = uuidv4();
  if (!sessionStorage.getItem('uuid')) {
    sessionStorage.setItem('uuid', uuid);
  }
}

{
  const searchBox = document.getElementById('react-app');
  if (typeof searchBox !== 'undefined' && searchBox != null) {
    App();
  }
}

{
  const formConfirmation = document.querySelector('.form-content-confirmation');
  if (typeof formConfirmation !== 'undefined' && formConfirmation != null)
    FormConfirmation();
}

{
  const floorplanFurniture = document.querySelector(
    '.floorplans__images--furniture'
  );
  if (typeof floorplanFurniture !== 'undefined' && floorplanFurniture != null)
    FloorplanFurniture();
}

{
  const faqQuickLinks = document.querySelector('.faqs-quick-links');
  if (typeof faqQuickLinks !== 'undefined' && faqQuickLinks != null)
    FaqQuickLinks();
}

{
  const sitePlan = document.getElementById('interactive-site-plan');
  if (typeof sitePlan !== 'undefined' && sitePlan != null) {
    SitePlanApp();
  }
}

{
  const hero = document.querySelector('.hero');
  if (typeof hero !== 'undefined' && hero != null) HeroSlider();
}

{
  const mobileMenu = document.querySelector('.mobile-menu');
  if (typeof mobileMenu !== 'undefined' && mobileMenu != null) {
    MobileMenu();
  }
}

{
  const heroNotiBar = document.querySelector('.notification-bar--hero');
  if (typeof heroNotiBar !== 'undefined' && heroNotiBar != null) {
    HeroNotificationBar();
  }
}

{
  const globalNotiBar = document.querySelector('.notification-bar--global');
  if (typeof globalNotiBar !== 'undefined' && globalNotiBar != null) {
    GlobalNotificationBar();
  }
}

{
  const txtimgslider = document.querySelector('.text-img-slider');
  if (typeof txtimgslider !== 'undefined' && txtimgslider != null) {
    TxtImgSlider();
  }
}

{
  const mobnewsslider = document.querySelector('.page-blocks__slides');
  if (typeof mobnewsslider !== 'undefined' && mobnewsslider != null) {
    MobNewsSlider();
  }
}

{
  const slider = document.querySelector('.slider');
  if (typeof slider !== 'undefined' && slider != null) {
    Slider();
  }
}

{
  const offerslider = document.querySelector('.offers');
  if (typeof offerslider !== 'undefined' && offerslider != null) {
    OfferSlider();
  }
}

{
  const specificationSlider = document.querySelector('.specifications');
  if (
    typeof specificationSlider !== 'undefined' &&
    specificationSlider != null
  ) {
    SpecificationSlider();
  }
}

{
  const contactBlock = document.querySelector('.contact-block__message');
  if (typeof contactBlock !== 'undefined' && contactBlock != null) {
    OpeningTimes();
  }
}

{
  const comingSoonCountDownElement = document.querySelector(
    '.coming-soon-countdown__timer'
  );
  if (
    typeof comingSoonCountDownElement !== 'undefined' &&
    comingSoonCountDownElement != null
  ) {
    ComingSoonCountDown(comingSoonCountDownElement);
  }
}

{
  const featureslider = document.querySelector('.feature-gallery');
  if (typeof featureslider !== 'undefined' && featureslider != null) {
    FeatureSlider();
  }
}

{
  const tabElement = document.querySelector('.tabbed-area');
  if (typeof tabElement !== 'undefined' && tabElement != null) Tabs();
}

{
  const floorplantabElement = document.querySelector('.floorplans');
  if (typeof floorplantabElement !== 'undefined' && floorplantabElement != null)
    FloorplanTabs();
}

{
  const map = document.querySelector('.map');

  if (typeof map !== 'undefined' && map) {
    FlexibleMap();
  }
}

{
  const enquirypage = document.querySelector('.enquires');

  if (typeof enquirypage !== 'undefined' && enquirypage) {
    EnquiryTabs();
  }
}

{
  const datepicker = document.querySelector('.datepicker');

  if (typeof datepicker !== 'undefined' && datepicker) {
    DatePicker();
  }
}

{
  const faqs = document.querySelector('.faqs');

  if (typeof faqs !== 'undefined' && faqs) {
    Faqs();
  }
}

{
  const faqs = document.querySelector('.faqs-accordion');

  if (typeof faqs !== 'undefined' && faqs) {
    Faqs();
  }
}

{
  const searchBoxCtn = document.querySelector('.hero__search-box-ctn');
  if (typeof searchBoxCtn !== 'undefined' && searchBoxCtn) {
    setTimeout(() => {
      searchBoxCtn.classList.add('hero__search-box-ctn--finished');
    }, 3000);
  }
}

{
  const plotCta = document.querySelector('.plot-cta');
  if (typeof plotCta !== 'undefined' && plotCta) {
    PlotCta();
  }
}

{
  const sitePlanRoot = document.getElementById('sitemap-root');
  if (typeof sitePlanRoot !== 'undefined' && sitePlanRoot != null) {
    SitePlan();
  }
}

{
  const singleDevelopment = document.querySelector('.single-development');
  if (typeof singleDevelopment !== 'undefined' && singleDevelopment != null) {
    DevelopmentNewsBanner();
    AudienceCookie();
    ContentSwitcher();
  }
}

{
  const openingHours = document.querySelector('.opening-times');
  if (typeof openingHours !== 'undefined' && openingHours) {
    OpeningHours();
  }
}
